import {chakra, Button, ButtonProps, Image} from "@chakra-ui/react";
import {IMAGE_PREFIX} from '../env';

type Props = ButtonProps & {
  label: string,
};

export default function AddButton({label, ...props}: Props) {
  return (
    <Button
      {...props}
      type="button"
      display="flex"
      flexDirection="column"
      gap="1"
      h="auto"
      color="blue.500"
    >
      <Image src={`${IMAGE_PREFIX}icon-graph-02.png`} alt="" w="10" h="10" />
      <chakra.span>{label}</chakra.span>
      {/* TODO: 追加後フォーカス */}
    </Button>
  );
}
